import { createSelectorMemoized } from "@components/DataGrid/utils/createSelector";
import { GridRowId, GridRowModel, gridRowsLookupSelector } from "@mui/x-data-grid-premium";
import { GridStatePremium } from "@mui/x-data-grid-premium/models/gridStatePremium";
import { createSelector } from "reselect";
import "../../../models/dataGridProps.ts";

export const gridRowVisibilitySelectionStateSelector = (state: GridStatePremium) => state.rowVisibilitySelection;

export const visibilityGridRowsCountSelector = createSelector(
  gridRowVisibilitySelectionStateSelector,
  (visibility) => visibility.length,
);

export const visibilityGridRowsSelector = createSelectorMemoized(
  gridRowVisibilitySelectionStateSelector,
  gridRowsLookupSelector,
  (visibleRows, rowsLookup) =>
    new Map<GridRowId, GridRowModel>(visibleRows.map((id) => [id, rowsLookup[id]])),
);

export const visibilityIdsLookupSelector = createSelectorMemoized(
  gridRowVisibilitySelectionStateSelector,
  (visibilitySelection) =>
    visibilitySelection?.reduce<Record<GridRowId, GridRowId>>((lookup, rowId) => {
      lookup[rowId] = rowId;
      return lookup;
    }, {}) || {},
);
